import { render, staticRenderFns } from "./ConfigurationList.vue?vue&type=template&id=9bf5e89e&"
import script from "./ConfigurationList.vue?vue&type=script&lang=js&"
export * from "./ConfigurationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports